import { render, staticRenderFns } from "./all-detail.vue?vue&type=template&id=4404bb79&scoped=true"
import script from "./all-detail.vue?vue&type=script&lang=js"
export * from "./all-detail.vue?vue&type=script&lang=js"
import style0 from "./all-detail.vue?vue&type=style&index=0&id=4404bb79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404bb79",
  null
  
)

export default component.exports